import { createApp } from 'vue';
import { eventBus } from '@tools/event-bus';
import ExtendDealModalComponent from './organization/adaf/modal-extend-deal-component.vue';

/**
 * Init Deal Modal Component
 *
 * Wrapper of the 'Extend Modal Component'.
 * Handles opening modal and setting data from EventBus.
 */
export const adafDealActionsExtend = () => {
  const elementId = '#adaf-deal-extends-modals';
  if (!document.querySelector(elementId)) {
    return null;
  }

  const component = {
    components: {
      'modal-deal-extend': ExtendDealModalComponent,
    },
    data() {
      return {
        loading: false,
        isDealEndModalOpened: false,
        isDealExtendModalOpened: false,
        dealId: null,
        endDate: null,
        accountManagerEmail: '',
        dealBuyerFullname: '',
      };
    },
    mounted() {
      eventBus.addEventListener('deal-extend-modal', (args) => {
        this.extendDeal(args.detail);
      });
    },
    methods: {
      /**
       * Clear data
       */
      clear() {
        this.dealId = null;
      },
      /**
       * This method displays the extend deal modal.
       */
      showDealExtendModal() {
        this.isDealExtendModalOpened = true;
      },
      /**
       * This method closes the extend deal modal.
       */
      closeDealExtendModal() {
        this.isDealExtendModalOpened = false;
        this.clear();
      },
      /**
       * This method call action to extend deal.
       *
       * @param event
       */
      extendDeal(event) {
        const { dealId, dealBuyerFullname } = event;
        this.dealId = dealId;
        this.dealBuyerFullname = dealBuyerFullname;

        this.showDealExtendModal();
      },
    },
  };

  return createApp(component).mount(elementId);
};
